<div class="thank-you-container">
  <img alt="thank you" src="/img/documents.png">

  <div class="text header">
    <span>{{ 'ThankYou.Title' | translate | translateCut:0 }} &nbsp;</span>
    <br>
    <span class="red">
      {{ 'ThankYou.Title' | translate | translateCut:1 }}
    </span>
  </div>

  <img alt="documents info" src="/img/documents-info.png">

  <div [innerHTML]="'ThankYou.Info.Title' | translate" class="text green mt-1">
  </div>

  <div [innerHTML]="'ThankYou.Info.SubTitle' | translate" class="text">
  </div>

  <button (click)="redirectService.redirectToIL()" class="back-to-home mt-3">
    {{ 'ThankYou.BackToHome' | translate }}
    <span class="symbol"> &larr; </span>
  </button>
</div>
